import { render, staticRenderFns } from "./CaseNote.vue?vue&type=template&id=35bcfaea"
import script from "./CaseNote.vue?vue&type=script&lang=js"
export * from "./CaseNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports